import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<defs> <path id="paradise-kibana-icon_svg__a" d="M.185.655h23.314V16H.185z"/> </defs> <g fill="none" fill-rule="evenodd"> <path d="M28 0H3v12c4.325 0 8.385 1.113 11.933 3.047z" fill="#F04E98"/> <path d="M3 12v16.788l11.933-13.74A24.85 24.85 0 0 0 3 12" fill="#343741"/> <g transform="translate(4 16)"> <mask id="paradise-kibana-icon_svg__b" fill="#fff"> <use xlink:href="#paradise-kibana-icon_svg__a"/> </mask> <path d="M13.51.655 1.267 14.757.185 16h23.314C22.219 9.697 18.56 4.264 13.51.655" fill="#00BFB3" mask="url(#paradise-kibana-icon_svg__b)"/> </g> </g>' }
  })
);